function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createContext, useContext, useMemo } from 'react';
import { useActorRef, useSelector as useSelectorXstate } from '@xstate/react';
import { assign, createMachine } from 'xstate';
import { useReactFlow } from 'reactflow';
import { isEqual, omit } from 'lodash';
import { shortUUID } from "../../utils/id";
import { NodeType } from "./types";
import { FormQuestionPropertySchema, TruthTable } from "./data";
import { useRequirementTemplate } from "./data/requirementTemplate";
import { convertToDictionary, shouldUseQuestionOptionsForHandles, getQuestionOptions, isSchemaBAssignableToSchemaA, getEmptyOutcomeDataValue } from "./utils";
import { getGeneralInformationFromRequirementTemplate } from "./GeneralInformation";
import { assert } from "../../utils/assert";
import { produce } from 'immer';
import { isMatching, P } from 'ts-pattern';

/**
 * The "extended state" for the state machine.  In other words, all the other
 * stateful information besides the main "state" value/key
 *
 * @see: https://stately.ai/docs/context
 * @see: https://en.wikipedia.org/wiki/UML_state_machine#Extended_states
 */

/**
 * All the events that the state machine understands
 *
 * Note: Events should be imperative verbs.  States should be present-tense /
 * gerunds
 */

/**
 * All the 'named' actions for the state machine that are declared
 * subsequently via .provide in the `useActorRef` hook. This is
 * useful when we need an action to leverage some other react hook
 */
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * The state machine that controls the state of the requirement designer
 * including all 3 steps.  Currently step 3 is the most complicated and has
 * several "sub-states"
 */
export var machine = createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QAoC2BDAxgCwJYDswBKAOlgBcwAHAfQEYBiAOQFEANAFQG0AGAXUSgqAe1i5yuYfkEgAHogC0ANgAsJABxK6AdgDMPAKwBOdXRVL1ugDQgAnojo86JE3V3qDbuuvMWAvn42aFh4hKQU1DQATMzs3PwyImISUjLyCJ5GJN4GSlEGelFGuiY29gh0UWpGBcW6BgYq2pYG6gFBGDgExGSUtDEACgBKLABqvAJIIEniktJT6cpZRtoFOnQFPE50SmWKldokrSoG7nn6PPptgSDBXWG9kTEAqgMAIgCCHCw0AGIA8kMALITRKiWapBaIKJ0LKNTS5FRnXTNPYIBQbdQkPSGXTmJoGHhGKrtW6dUI9CK0XQMYZjUFTGYpeagdLGJQkfRKIw89RRCy6NxojFKQ4bFQ7HRRKLaIw8Zqku4U8J9Gi6EgEWboAA2DCB-1GPyY-zeLAZQnBzLSiHxBk5xJMSKUjSMwu03hIKnMlVh9R0eUV5O6Ksi6s1Eh1DAAyiwADIsADCHBoxtN5umlrm1oQKhhdului5EqqsOFSOc3nUqws6ksun5BkDIWDj2pGvwWt1zyYMfjSZTJrNCUZmchrJtzTF9Wa6h5UR4zoMwp8h00SnqeVh2i2uib90pqrDHYjuv+AxYTAHppoHAAmueo+mmVmoQhBXkNIKtvyimYomiqnVFRim0ecokLBoGj3ZVWzVdtOwYFg3gASWTVMh0mC1khfccEHybQ1HrBc3A3S5tDRMxnA8YD5QaKo8i9aCWypODw1wSMRn1Q0rwwsFsLHOQbXqLFzFnWcvBOci7GhNRc30Ax8N-BoTiYh4WKPBCPjeN4aCQgBxXiR34llBJzeUskMCxmlzSdRWFPE1A2dc11yEp-VUg9Q3gk9ozjRNk30wysIhEz0hKBcjhWXN1waLxdmk9FAJIGUdiRcDcmJJoPJDNs2Mjbte383S3gMp9R1CxAUWlZLcgsVRKmdYUzDURpt3lNxyzxRsbiVZjD289jdU4g0fkKpMkOK0rh2Cq1Xwclqa0uet52KYVnRcOgcnXFR5RUdRDGy2CNJ8gZngAIVjZCowACRoEYAEVnmQziL2Tb4gQGWMviCjNjOzIpc2yHgq3MH8fCUeLygUPEsTIiVgdlDwyMO9SSBwYRwXwKAaHwYQIDAGhyFsKgwAYBNY3+GMeJve8WEfabfpC7NhOcFZClAolrASpLgJRVZHFrEGlBR-r0cx7HcfxwnidJhNrv+SmjUHGnzzKv65o2CsVn5XNNt0dcufKPaomSlYCnqecFNaEWvLFsQsZxvGCaJkmGC0nSLx09C1aZubQNXGFgdMPEorRCDPyJTadG0bdjhtttIFmB3Jdlj4mATONitQ5CmD0nifdm3D+R5I5vD0OVVCiTQKI-TxpVUJE9u6jpmzU-rE4kZOnbJ-4mF+Z6gSzjgc7z72GefAT0irwGFx8UxTG5VYpPKPETcA-WeFBiHpXjuCO4ICXu7GtDlfez7voLnDTPretsQXWLVgKZ11DRGoTdOQUmnqL1VF39V967vjMm1004GRoMMM8LAhh3hoKMD4sZng-QnhVN899OT5C0K0SwqhDaIHBslWEVYjC+maCSHqQY25eQAYfIB7saAJg+DGS+k9KrOh4J6NwxRfCeAUsvBwsJ2EEULEtMw+0Y5-xINQx2QDTTxm+PQxhSDyrM1MHaWUPJgKmD2jwKoFF6zOHdJvBc2gLAbBMRIqRKc3baRoP8Z4HAEz-CBEo9WRcdiHH5HiAivp5T-gShYLIqgagmNFDtEw2gLEQCTjQ0mSFUK2PsY45xzCUGwnXMlY2zp9A1FMHwhAASSBBLamYYw85hbkNbp5BOUTO4xMQihZMjimANOQr3emmFGaF1MjoeUnI8iEhMZUPkhY0QFKCU-UJRJZyROidI2JDSEkOKcT8T4HAPgpOzGYbc2RNab3ApYXR-jZyFOAsUk4xIFwzNqXM4BoCfh2KWck8eyi5onBNjogsAtCy5hUBRSOhSGiin5EoHRm9rgt33DlOC6AIBRIdsIAAruQTAwhUCp3TpnB5SSXG+yLmE5KRRBRuRMfWPJph2EojXPrZSEpykQpgqjGFcLsaIuRai2Wvd+7AkWdijZr5wIl3hBzAoO1uSQ0QMQk2DotmbTKXiK5B8aCspRWismacM6xh5csvleKiQEuKJw-0pK-kficJ4bk5h3AnGbmSSpUL-41MVcq9lPc+4Dy1U8jpyD-olDhHtYVBEFxGHFRUAR2IkT6ELKI+UESKmQqOpIx1DsUX4EdVIWArquWDzicPXO9De4tLaTq0y4FKgaEcEYJosp5y5iXAlSiHJiFmCuO6RwEoFXJqkGm-AGaGEYs1Tmke+bmnZyLc81xJab5339rmYN246B6MMC4PkegTHzj0OC218bUZSOdWimgEB0DkHQJm91WLlk0FWes8duLJ0KUKZvExspqUeAorw7IfpPAVuMPrDtLKkUqoJoe49ar+0epWV8a9XqXlF31ibdwWxtygQtS-etzo1DbnElUQwQdN29UoW2AATmAVAwgABuiqrF9o1XdFgXEh1j2gxOsKxJ3kKVnJvNK-JhSnCyBKWtMp1ygUqBI4jpGKOAI5W67lw1RgMcHMWsKqh2ErGIZOfapi8nKHyASoos53BV1nHSrdDL+pUARQAI21LgWAoRsaUFQFQbUR70U0dOhdK6t0HpPRekwN6dHz7fEUzJJoGg9rrijl6eUTV0n7WDZcCUBEmjFAkeZqzNm7OExI05lzp7uXucujdWjj1np0dejeALX0gs3q6VPCwa9lKFBBV1YU-JYYxxyPOuqmgAg3BTvAKY+HiB8VvYsQFhT-QNBMR4SVTVjF9PXKEnwCl3C7zoCN2rihCRYi0CYqbFhjBCgSgoGEJAtiiQ8DsZbOjd5RA21fdIEMjigX2tKYuwbGitecOd90xhGhfqcLuONpnQz3ZYRUfW6oDslD5HyHa9ZhSqY0BDLqb9fxGAkXlbUYOUH6PfkjAiMJayijyZWlwrazAmEuMDeUEi7aUadtLEmOPmY6ECY4SuBFjC-ISvUdhCWnBGYIlWG1Q37WJtmSnFn-Kf3YkLIYknm9cH5JlIU6iWTuS8OM2LhNTKnUAfZdLtx85OQFGLrOStc60S1jY9KURMVER-qVQbtFRvunEnVPrWHhJCRvx5+URwJRsRZO-IHUwTuU3doGzNB7DgueFJxDtd0XpaUUUEy4A2oEvEbGME7vdQGj3oDd+kSizhocmCrthhH9btum6KDUTcVRcyiZI+Rhn+Ni82nyCbMw8oLfbbMDxsnPTLiByKDooH9K+peTS9Z2ziqHM5coJ3vCpwGvAxdCSiUdaoa5HYZtZDhDDBtt634IAA */
  types: {},
  context: function context(_ref) {
    var _input$workflow, _input$form, _input$generalInforma;
    var input = _ref.input;
    return {
      selectedNodeId: null,
      selectedEdgeId: null,
      selectedRowIdx: null,
      previousNodeState: null,
      isFullscreen: false,
      workflow: (_input$workflow = input === null || input === void 0 ? void 0 : input.workflow) !== null && _input$workflow !== void 0 ? _input$workflow : {
        nodes: [{
          id: '1',
          position: {
            x: 20,
            y: 20
          },
          type: NodeType.Start,
          data: {
            templateId: 'start'
          }
        }],
        edges: []
      },
      form: (_input$form = input === null || input === void 0 ? void 0 : input.form) !== null && _input$form !== void 0 ? _input$form : {
        components: []
      },
      generalInformation: (_input$generalInforma = input === null || input === void 0 ? void 0 : input.generalInformation) !== null && _input$generalInforma !== void 0 ? _input$generalInforma : getGeneralInformationFromRequirementTemplate()
    };
  },
  initial: 'step_1',
  states: {
    step_1: {
      description: 'The step to enter the general requirement template information',
      on: {
        NEXT: {
          target: 'step_2',
          actions: assign(updateGeneralInformation)
        }
      }
    },
    step_2: {
      description: 'The form designer step for the requirement designer',
      on: {
        NEXT: 'step_3',
        PREV: 'step_1',
        UPDATE_FORM: {
          actions: assign(updateForm)
        }
      }
    },
    step_3: {
      description: 'The workflow designer step for the requirement designer',
      initial: 'initial',
      on: {
        PREV: 'step_2',
        TOGGLE_FULLSCREEN: {
          actions: assign(function (_ref2) {
            var context = _ref2.context;
            return _objectSpread(_objectSpread({}, context), {}, {
              isFullscreen: !context.isFullscreen
            });
          })
        }
      },
      states: {
        initial: {
          description: 'Dormant / normal state',
          on: {
            MOVE_NODE: {
              actions: assign(moveNode)
            },
            SELECT_NODE: {
              actions: assign(selectNode)
            },
            UNSELECT_NODE: {
              actions: assign(unselectNode)
            },
            OPEN_NODE_TYPES: 'choosing_node_type',
            EDIT_NODE: {
              target: 'editing_node',
              actions: [{
                type: 'setViewPortCenter'
              }]
            },
            REMOVE_NODE: 'removing_node',
            CONFIRM_REMOVING_NODE: {
              actions: assign(removeSelectedNode)
            },
            ADD_EDGE: {
              actions: assign(addEdge)
            },
            SELECT_EDGE: {
              actions: assign(selectEdge)
            },
            UNSELECT_EDGE: {
              actions: assign(unselectEdge)
            },
            REMOVE_SELECTED_EDGE: {
              actions: assign(removeSelectedEdge)
            },
            PUBLISH_REQUIREMENT_TEMPLATE: 'publishing_template'
          }
        },
        choosing_node_type: {
          description: 'Opens the menu where users pick the node type',
          on: {
            CLOSE_NODE_TYPES: 'initial',
            CHOOSE_NODE_TYPE: {
              target: 'editing_node',
              actions: [assign(addEmptyNode), {
                type: 'setViewPortCenter'
              }]
            },
            ADD_END_NODE: {
              target: 'initial',
              actions: [assign(addEmptyNode), {
                type: 'setViewPortCenter'
              }]
            }
          }
        },
        editing_node: {
          description: 'Opens the property panel when a user wants to edit a node',
          on: {
            CANCEL_EDITING_NODE: {
              target: 'initial',
              actions: [assign(revertNode), assign(unselectNode)]
            },
            CONFIRM_EDITING_NODE: 'initial',
            SELECT_NODE_TEMPLATE: {
              actions: assign(selectNodeTemplate)
            },
            CHANGE_PROPERTY_VALUE: {
              actions: assign(changePropertyValue)
            },
            // Truth Table Actions
            ADD_CASE: {
              actions: assign(addCase)
            },
            DELETE_CASE: {
              actions: assign(deleteCase)
            },
            MOVE_CASE_UP: {
              actions: assign(moveCaseUp)
            },
            MOVE_CASE_DOWN: {
              actions: assign(moveCaseDown)
            },
            ADD_OUTCOME: {
              target: 'adding_outcome',
              actions: assign({
                selectedRowIdx: function selectedRowIdx(_ref3) {
                  var event = _ref3.event;
                  return event.payload.rowIdx;
                }
              })
            },
            EDIT_OUTCOME: {
              target: 'editing_outcome',
              actions: assign({
                selectedRowIdx: function selectedRowIdx(_ref4) {
                  var event = _ref4.event;
                  return event.payload.rowIdx;
                }
              })
            },
            EDIT_CONDITIONS: {
              target: 'editing_conditions',
              actions: assign({
                selectedRowIdx: function selectedRowIdx(_ref5) {
                  var event = _ref5.event;
                  return event.payload.rowIdx;
                }
              })
            },
            EDIT_OUTCOME_DATA: {
              target: 'editing_outcome_data',
              actions: assign({
                selectedRowIdx: function selectedRowIdx(_ref6) {
                  var event = _ref6.event;
                  return event.payload.rowIdx;
                }
              })
            },
            CHANGE_OUTCOME: {
              actions: assign(changeOutcome)
            }
          }
        },
        adding_outcome: {
          description: 'Opens the dialog to add an outcome',
          on: {
            CANCEL_OUTCOME: 'editing_node',
            CONFIRM_OUTCOME: {
              target: 'editing_node',
              actions: assign(addOutcome)
            }
          }
        },
        editing_outcome: {
          description: 'Opens the dialog to edit an outcome',
          on: {
            CANCEL_OUTCOME: 'editing_node',
            CONFIRM_OUTCOME: {
              target: 'editing_node',
              actions: assign(updateOutcome)
            }
          }
        },
        editing_conditions: {
          description: 'Opens the dialog to add conditions to a row',
          on: {
            CONFIRM_EDITING_CONDITIONS: {
              target: 'editing_node',
              actions: assign(updateConditions)
            },
            CANCEL_EDITING_CONDITIONS: 'editing_node'
          }
        },
        editing_outcome_data: {
          description: 'Opens the dialog to edit outcome data for a row',
          on: {
            CONFIRM_OUTCOME_DATA: {
              target: 'editing_node',
              actions: assign(updateOutcomeData)
            },
            CANCEL_OUTCOME_DATA: 'editing_node'
          }
        },
        removing_node: {
          description: 'Opens the dialog that allows the user to remove a node',
          on: {
            CANCEL_REMOVING_NODE: {
              target: 'initial'
            },
            CONFIRM_REMOVING_NODE: {
              target: 'initial',
              actions: assign(removeSelectedNode)
            }
          }
        },
        publishing_template: {
          description: 'Opens a dialog to allow a user to confirm publishing the requirement template',
          on: {
            CANCEL_PUBLISH_REQUIREMENT_TEMPLATE: {
              target: 'initial'
            },
            CONFIRM_PUBLISH_REQUIREMENT_TEMPLATE: {
              target: 'initial'
            }
          }
        }
      }
    }
  }
});

/**
 * Returns an updated context to move a node to a particular position
 */
function moveNode(_ref7) {
  var context = _ref7.context,
    event = _ref7.event;
  return _objectSpread(_objectSpread({}, context), {}, {
    selectedNodeId: event.payload.id,
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      nodes: context.workflow.nodes.map(function (node) {
        if (node.id === event.payload.id) {
          return _objectSpread(_objectSpread({}, node), {}, {
            position: event.payload.position
          });
        }
        return node;
      })
    })
  });
}

/**
 * Returns an updated context to select a node
 * Note that any selected edge is unselected as well
 */
function selectNode(_ref8) {
  var context = _ref8.context,
    event = _ref8.event;
  return produce(context, function (draft) {
    var _iterator = _createForOfIteratorHelper(draft.workflow.nodes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var node = _step.value;
        node.zIndex = node.id === event.payload.id ? 1 : 0;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var selectedNode = draft.workflow.nodes.find(function (node) {
      return node.id === event.payload.id;
    });
    assert(selectedNode, 'Selected node not found');
    draft.previousNodeState = {
      node: selectedNode,
      edges: draft.workflow.edges.filter(function (edge) {
        return edge.source === event.payload.id;
      })
    };
    draft.selectedNodeId = event.payload.id;
    draft.selectedEdgeId = null;
  });
}

/**
 * Returns an updated context to unselect a node
 */
function unselectNode(_ref9) {
  var context = _ref9.context;
  return _objectSpread(_objectSpread({}, context), {}, {
    selectedNodeId: null
  });
}

/**
 * Returns an updated context with an "empty" (aka "placeholder") node.  The
 * user must fill out other details in the property panel before a workflow can
 * be saved with this empty node
 */
function addEmptyNode(_ref10) {
  var context = _ref10.context,
    event = _ref10.event;
  var nodeId = shortUUID();
  var rightMostNodePosition = getRightMostNodePosition(context.workflow.nodes);
  var newNode = {
    data: {
      templateId: event.type === 'CHOOSE_NODE_TYPE' ? event.payload.templateId : 'end'
    },
    id: nodeId,
    position: {
      x: rightMostNodePosition.isStartOrEndNode ? rightMostNodePosition.x + 100 : rightMostNodePosition.x + 400,
      y: rightMostNodePosition.y
    },
    type: event.type === 'CHOOSE_NODE_TYPE' ? event.payload.type : NodeType.End
  };
  return _objectSpread(_objectSpread({}, context), {}, {
    selectedNodeId: nodeId,
    previousNodeState: {
      node: newNode,
      edges: [],
      isNewNode: true
    },
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      nodes: [].concat(_toConsumableArray(context.workflow.nodes), [newNode])
    })
  });
}

/**
 * Returns rightmost node in workflow to
 * help positioning when adding new node
 */
function getRightMostNodePosition(nodes) {
  var rightmostNode = nodes.reduce(function (nodeA, nodeB) {
    return nodeA.position.x > nodeB.position.x ? nodeA : nodeB;
  });
  return {
    x: rightmostNode.position.x,
    y: rightmostNode.position.y,
    isStartOrEndNode: rightmostNode.type === 'start' || rightmostNode.type === 'end'
  };
}

/**
 * Returns an updated context with the selected node removed
 */
function removeSelectedNode(_ref11) {
  var context = _ref11.context;
  return _objectSpread(_objectSpread({}, context), {}, {
    selectedNodeId: null,
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      edges: context.workflow.edges.filter(function (edge) {
        return context.selectedNodeId !== edge.source && context.selectedNodeId !== edge.target;
      }),
      nodes: context.workflow.nodes.filter(function (node) {
        return context.selectedNodeId !== node.id;
      })
    })
  });
}

/**
 * Returns an updated context to select a node template
 */
function selectNodeTemplate(_ref12) {
  var context = _ref12.context,
    event = _ref12.event;
  var _event$payload = event.payload,
    templateId = _event$payload.templateId,
    properties = _event$payload.properties;
  return _objectSpread(_objectSpread({}, context), {}, {
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      nodes: context.workflow.nodes.map(function (node) {
        return context.selectedNodeId === node.id ? _objectSpread(_objectSpread({}, node), {}, {
          data: {
            templateId: templateId,
            properties: properties
          }
        }) : node;
      }),
      edges: context.workflow.edges.filter(function (edge) {
        return edge.source !== context.selectedNodeId;
      })
    })
  });
}

/**
 * Returns an updated context when a node is reverted (i.e. when an editing action is cancelled)
 */
function revertNode(_ref13) {
  var context = _ref13.context;
  var previousNodeState = context.previousNodeState;
  if (!previousNodeState) {
    return context;
  }
  if (previousNodeState.isNewNode) {
    return _objectSpread(_objectSpread({}, context), {}, {
      workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
        nodes: context.workflow.nodes.filter(function (node) {
          return node.id !== context.selectedNodeId;
        })
      })
    });
  }
  return _objectSpread(_objectSpread({}, context), {}, {
    previousNodeState: null,
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      nodes: context.workflow.nodes.map(function (node) {
        return context.selectedNodeId === node.id ? previousNodeState.node : node;
      }),
      edges: replaceOrInsertEdges(context.workflow.edges, previousNodeState.edges)
    })
  });
}

/**
 * Replaces or inserts edges into the existing edges
 */
function replaceOrInsertEdges(existingEdges, newEdges) {
  var newEdgeIds = newEdges.map(function (edge) {
    return edge.id;
  });
  return existingEdges.filter(function (edge) {
    return !newEdgeIds.includes(edge.id);
  }).concat(newEdges);
}

/**
 * Returns an updated context when an edge is added
 */
function addEdge(_ref14) {
  var context = _ref14.context,
    event = _ref14.event;
  return _objectSpread(_objectSpread({}, context), {}, {
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      edges: [].concat(_toConsumableArray(context.workflow.edges), [{
        id: shortUUID(),
        source: event.payload.source,
        sourceHandle: event.payload.sourceHandle,
        target: event.payload.target
      }])
    })
  });
}

/**
 * Returns an updated context when an edge is selected
 * Note that any selected node is unselected as well
 */
function selectEdge(_ref15) {
  var context = _ref15.context,
    event = _ref15.event;
  return _objectSpread(_objectSpread({}, context), {}, {
    selectedEdgeId: event.payload.id,
    selectedNodeId: null
  });
}

/**
 * Returns an updated context to unselect an edge
 */
function unselectEdge(_ref16) {
  var context = _ref16.context;
  return _objectSpread(_objectSpread({}, context), {}, {
    selectedEdgeId: null
  });
}

/**
 * Returns an updated context with the selected edge removed
 */
function removeSelectedEdge(_ref17) {
  var context = _ref17.context;
  return _objectSpread(_objectSpread({}, context), {}, {
    selectedEdgeId: null,
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      edges: context.workflow.edges.filter(function (edge) {
        return edge.id !== context.selectedEdgeId;
      })
    })
  });
}

/**
 * Changes the value of a property
 */
function changePropertyValue(_ref18) {
  var context = _ref18.context,
    event = _ref18.event;
  if (!context.selectedNodeId) return context;
  var selectedNode = context.workflow.nodes.find(function (node) {
    return node.id === context.selectedNodeId;
  });
  if (!selectedNode) return context;

  // If we change the question for the decision node, then the handles may
  // change, which means we need to remove the edges
  var shouldRemoveEdges = selectedNode.type === 'decision' && FormQuestionPropertySchema.safeParse(event.payload.schema).success;
  return _objectSpread(_objectSpread({}, context), {}, {
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      nodes: context.workflow.nodes.map(function (node) {
        if (node.id !== context.selectedNodeId) {
          return node;
        }
        if (isPropertyEmpty(event.payload.value)) {
          return _objectSpread(_objectSpread({}, node), {}, {
            data: _objectSpread(_objectSpread({}, node.data), {}, {
              properties: omit(node.data.properties, event.payload.key)
            })
          });
        }
        return _objectSpread(_objectSpread({}, node), {}, {
          data: _objectSpread(_objectSpread({}, node.data), {}, {
            properties: _objectSpread(_objectSpread({}, node.data.properties), {}, _defineProperty({}, event.payload.key, coercePropertyValue(event.payload.value, event.payload.schema)))
          })
        });
      }),
      edges: shouldRemoveEdges ? context.workflow.edges.filter(function (edge) {
        return edge.source !== context.selectedNodeId;
      }) : context.workflow.edges
    })
  });
}

/**
 * Returns an updated context with an updated form
 *
 * Note: This action also removes orphaned edges. This is necessary because the
 * user may have removed a question or a question option that is referenced in
 * the workflow
 */
function updateForm(_ref19) {
  var context = _ref19.context,
    event = _ref19.event;
  var nodesMap = convertToDictionary(context.workflow.nodes);
  var nodeTemplatesMap = convertToDictionary(event.payload.nodeTemplates);
  return _objectSpread(_objectSpread({}, context), {}, {
    form: event.payload.form,
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      edges: context.workflow.edges.filter(function (edge) {
        var _getQuestionOptions;
        var sourceNode = nodesMap[edge.source];
        if (!(sourceNode !== null && sourceNode !== void 0 && sourceNode.data.templateId)) return false;
        var sourceNodeTemplate = nodeTemplatesMap[sourceNode.data.templateId];
        var handleHasBeenRemoved = edge.sourceHandle && shouldUseQuestionOptionsForHandles(sourceNodeTemplate) && !((_getQuestionOptions = getQuestionOptions({
          data: sourceNode.data,
          nodeTemplate: sourceNodeTemplate,
          components: event.payload.form.components
        })) !== null && _getQuestionOptions !== void 0 && _getQuestionOptions.find(function (option) {
          return option.value === edge.sourceHandle;
        }));
        if (handleHasBeenRemoved) {
          return false;
        }
        return true;
      })
    })
  });
}

/**
 * Returns an updated context with an updated General Information section
 */
function updateGeneralInformation(_ref20) {
  var _event$payload2;
  var context = _ref20.context,
    event = _ref20.event;
  return _objectSpread(_objectSpread({}, context), {}, {
    generalInformation: (_event$payload2 = event.payload) !== null && _event$payload2 !== void 0 && _event$payload2.generalInformation ? event.payload.generalInformation : context.generalInformation
  });
}

/**
 * Adds an outcome to the selected node
 */
function addOutcome(_ref21) {
  var context = _ref21.context,
    event = _ref21.event;
  return _objectSpread(_objectSpread({}, context), {}, {
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      nodes: context.workflow.nodes.map(function (node) {
        var _node$data$properties;
        if (node.id !== context.selectedNodeId) {
          return node;
        }
        var result = TruthTable["default"]({
          defaultOutcome: '',
          rows: []
        }).safeParse((_node$data$properties = node.data.properties) === null || _node$data$properties === void 0 ? void 0 : _node$data$properties[event.payload.propertyKey]);
        if (!result.success) {
          return node;
        }
        var oldTruthTable = result.data;
        var newTruthTable = context.selectedRowIdx === 'default' ? {
          defaultOutcome: event.payload.outcome.id,
          rows: oldTruthTable.rows
        } : _objectSpread(_objectSpread({}, oldTruthTable), {}, {
          rows: oldTruthTable.rows.map(function (row, idx) {
            var _event$payload$outcom, _event$payload$outcom2;
            if (idx !== context.selectedRowIdx) {
              return row;
            }
            var outcomeDataId = Object.keys(((_event$payload$outcom = event.payload.outcome.data) === null || _event$payload$outcom === void 0 ? void 0 : _event$payload$outcom.properties) || {})[0];
            var outcomeDataSchema = firstPropertyValue(((_event$payload$outcom2 = event.payload.outcome.data) === null || _event$payload$outcom2 === void 0 ? void 0 : _event$payload$outcom2.properties) || {});
            if (outcomeDataId) {
              return _objectSpread(_objectSpread({}, row), {}, {
                outcome: _objectSpread(_objectSpread({}, row.outcome), {}, {
                  id: event.payload.outcome.id,
                  data: _defineProperty({}, outcomeDataId, getEmptyOutcomeDataValue(outcomeDataSchema))
                })
              });
            }
            return _objectSpread(_objectSpread({}, row), {}, {
              outcome: _objectSpread(_objectSpread({}, row.outcome), {}, {
                id: event.payload.outcome.id
              })
            });
          })
        });
        return _objectSpread(_objectSpread({}, node), {}, {
          data: _objectSpread(_objectSpread({}, node.data), {}, {
            properties: _objectSpread(_objectSpread({}, node.data.properties), {}, _defineProperty({}, event.payload.propertyKey, newTruthTable)),
            outcomes: [].concat(_toConsumableArray(node.data.outcomes || []), [event.payload.outcome])
          })
        });
      })
    })
  });
}

/**
 * Updates an outcome's display name and/or data
 */
function updateOutcome(_ref22) {
  var context = _ref22.context,
    event = _ref22.event;
  return _objectSpread(_objectSpread({}, context), {}, {
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      nodes: context.workflow.nodes.map(function (node) {
        var _node$data$outcomes, _node$data$properties2, _node$data$outcomes2;
        if (node.id !== context.selectedNodeId) {
          return node;
        }
        var newOutcomeDef = event.payload.outcome;
        var oldOutcomeDef = (_node$data$outcomes = node.data.outcomes) === null || _node$data$outcomes === void 0 ? void 0 : _node$data$outcomes.find(function (outcome) {
          return outcome.id === outcome.id;
        });
        assert(oldOutcomeDef, 'Could not find the outcome to update');
        return _objectSpread(_objectSpread({}, node), {}, {
          data: _objectSpread(_objectSpread({}, node.data), {}, {
            properties: _objectSpread(_objectSpread({}, node.data.properties), {}, _defineProperty({}, event.payload.propertyKey, resetOutcomeDataIfNeeded({
              propertyValue: (_node$data$properties2 = node.data.properties) === null || _node$data$properties2 === void 0 ? void 0 : _node$data$properties2[event.payload.propertyKey],
              oldOutcomeDef: oldOutcomeDef,
              newOutcomeDef: newOutcomeDef
            }))),
            outcomes: (_node$data$outcomes2 = node.data.outcomes) === null || _node$data$outcomes2 === void 0 ? void 0 : _node$data$outcomes2.map(function (outcome) {
              if (outcome.id === event.payload.outcome.id) {
                return newOutcomeDef;
              }
              return outcome;
            })
          })
        });
      })
    })
  });
}

/**
 * Resets the outcome data if the new outcome data schema is not compatible with the old one
 */
function resetOutcomeDataIfNeeded(_ref23) {
  var _oldOutcomeDef$data, _newOutcomeDef$data, _newOutcomeDef$data2;
  var propertyValue = _ref23.propertyValue,
    newOutcomeDef = _ref23.newOutcomeDef,
    oldOutcomeDef = _ref23.oldOutcomeDef;
  var oldTruthTable = TruthTable["default"]({
    defaultOutcome: '',
    rows: []
  }).parse(propertyValue);
  var oldOutcomeItemDef = firstPropertyValue((oldOutcomeDef === null || oldOutcomeDef === void 0 ? void 0 : (_oldOutcomeDef$data = oldOutcomeDef.data) === null || _oldOutcomeDef$data === void 0 ? void 0 : _oldOutcomeDef$data.properties) || {});
  var newOutcomeItemDef = firstPropertyValue(((_newOutcomeDef$data = newOutcomeDef.data) === null || _newOutcomeDef$data === void 0 ? void 0 : _newOutcomeDef$data.properties) || {});
  var newOutcomeItemId = Object.keys(((_newOutcomeDef$data2 = newOutcomeDef.data) === null || _newOutcomeDef$data2 === void 0 ? void 0 : _newOutcomeDef$data2.properties) || {})[0];
  var needToClearData = !isSchemaBAssignableToSchemaA({
    schemaA: newOutcomeItemDef,
    schemaB: oldOutcomeItemDef
  });
  if (!needToClearData) {
    return oldTruthTable;
  }
  return _objectSpread(_objectSpread({}, oldTruthTable), {}, {
    rows: oldTruthTable.rows.map(function (row) {
      if (row.outcome.id === newOutcomeDef.id) {
        return _objectSpread(_objectSpread({}, row), {}, {
          outcome: _objectSpread(_objectSpread({}, row.outcome), {}, {
            data: _defineProperty({}, newOutcomeItemId, getEmptyOutcomeDataValue(newOutcomeItemDef))
          })
        });
      }
      return row;
    })
  });
}

/**
 * Updates the outcome data for a row in the truth table
 */
function updateOutcomeData(_ref24) {
  var context = _ref24.context,
    event = _ref24.event;
  return _objectSpread(_objectSpread({}, context), {}, {
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      nodes: context.workflow.nodes.map(function (node) {
        if (node.id === context.selectedNodeId) {
          var _node$data$properties3;
          var oldTruthTable = TruthTable["default"]({
            defaultOutcome: '',
            rows: []
          }).parse((_node$data$properties3 = node.data.properties) === null || _node$data$properties3 === void 0 ? void 0 : _node$data$properties3[event.payload.propertyKey]);
          return _objectSpread(_objectSpread({}, node), {}, {
            data: _objectSpread(_objectSpread({}, node.data), {}, {
              properties: _objectSpread(_objectSpread({}, node.data.properties), {}, _defineProperty({}, event.payload.propertyKey, _objectSpread(_objectSpread({}, oldTruthTable), {}, {
                rows: oldTruthTable.rows.map(function (row, idx) {
                  if (idx === context.selectedRowIdx) {
                    return _objectSpread(_objectSpread({}, row), {}, {
                      outcome: _objectSpread(_objectSpread({}, row.outcome), {}, {
                        data: event.payload.data
                      })
                    });
                  }
                  return row;
                })
              })))
            })
          });
        }
        return node;
      })
    })
  });
}

/**
 * Adds an outcome to the selected node
 */
function changeOutcome(_ref25) {
  var context = _ref25.context,
    event = _ref25.event;
  return _objectSpread(_objectSpread({}, context), {}, {
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      nodes: context.workflow.nodes.map(function (node) {
        if (node.id === context.selectedNodeId) {
          var _node$data$properties4, _node$data$outcomes3, _node$data$outcomes3$;
          var result = TruthTable["default"]({
            defaultOutcome: '',
            rows: []
          }).safeParse((_node$data$properties4 = node.data.properties) === null || _node$data$properties4 === void 0 ? void 0 : _node$data$properties4[event.payload.propertyKey]);
          if (!result.success) {
            return node;
          }
          var outcomeDataDef = (_node$data$outcomes3 = node.data.outcomes) === null || _node$data$outcomes3 === void 0 ? void 0 : (_node$data$outcomes3$ = _node$data$outcomes3.find(function (outcome) {
            return outcome.id === event.payload.outcomeId;
          })) === null || _node$data$outcomes3$ === void 0 ? void 0 : _node$data$outcomes3$.data;
          var outcomeDataItemDef = firstPropertyValue((outcomeDataDef === null || outcomeDataDef === void 0 ? void 0 : outcomeDataDef.properties) || {});
          var outcomeDataItemId = Object.keys((outcomeDataDef === null || outcomeDataDef === void 0 ? void 0 : outcomeDataDef.properties) || {})[0];
          var oldTruthTable = result.data;
          var newTruthTable = event.payload.rowIdx === 'default' ? {
            defaultOutcome: event.payload.outcomeId,
            rows: oldTruthTable.rows
          } : _objectSpread(_objectSpread({}, oldTruthTable), {}, {
            rows: oldTruthTable.rows.map(function (row, idx) {
              if (idx !== event.payload.rowIdx) {
                return row;
              }
              if (outcomeDataItemId) {
                return _objectSpread(_objectSpread({}, row), {}, {
                  outcome: _objectSpread(_objectSpread({}, row.outcome), {}, {
                    id: event.payload.outcomeId,
                    data: _defineProperty({}, outcomeDataItemId, getEmptyOutcomeDataValue(outcomeDataItemDef))
                  })
                });
              }
              return _objectSpread(_objectSpread({}, row), {}, {
                outcome: _objectSpread(_objectSpread({}, row.outcome), {}, {
                  id: event.payload.outcomeId
                })
              });
            })
          });
          return _objectSpread(_objectSpread({}, node), {}, {
            data: _objectSpread(_objectSpread({}, node.data), {}, {
              properties: _objectSpread(_objectSpread({}, node.data.properties), {}, _defineProperty({}, event.payload.propertyKey, newTruthTable))
            })
          });
        }
        return node;
      })
    })
  });
}

/**
 * Adds a case/row to the truth table
 */
function addCase(_ref26) {
  var context = _ref26.context,
    event = _ref26.event;
  return _objectSpread(_objectSpread({}, context), {}, {
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      nodes: context.workflow.nodes.map(function (node) {
        if (node.id === context.selectedNodeId) {
          var _node$data$properties5;
          var result = TruthTable["default"]({
            defaultOutcome: '',
            rows: []
          }).safeParse((_node$data$properties5 = node.data.properties) === null || _node$data$properties5 === void 0 ? void 0 : _node$data$properties5[event.payload.propertyKey]);
          if (!result.success) {
            return node;
          }
          var oldTruthTable = result.data;
          var newTruthTable = _objectSpread(_objectSpread({}, oldTruthTable), {}, {
            rows: [].concat(_toConsumableArray(oldTruthTable.rows), [{
              conditions: {
                and: []
              },
              outcome: {
                id: ''
              }
            }])
          });
          return _objectSpread(_objectSpread({}, node), {}, {
            data: _objectSpread(_objectSpread({}, node.data), {}, {
              properties: _objectSpread(_objectSpread({}, node.data.properties), {}, _defineProperty({}, event.payload.propertyKey, newTruthTable))
            })
          });
        }
        return node;
      })
    })
  });
}

/**
 * Deletes a case/row from the truth table
 */
function deleteCase(_ref27) {
  var context = _ref27.context,
    event = _ref27.event;
  return _objectSpread(_objectSpread({}, context), {}, {
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      nodes: context.workflow.nodes.map(function (node) {
        if (node.id === context.selectedNodeId) {
          var _node$data$properties6;
          var result = TruthTable["default"]({
            defaultOutcome: '',
            rows: []
          }).safeParse((_node$data$properties6 = node.data.properties) === null || _node$data$properties6 === void 0 ? void 0 : _node$data$properties6[event.payload.propertyKey]);
          if (!result.success) {
            return node;
          }
          var oldTruthTable = result.data;
          var newTruthTable = _objectSpread(_objectSpread({}, oldTruthTable), {}, {
            rows: oldTruthTable.rows.filter(function (_, idx) {
              return idx !== event.payload.rowIdx;
            })
          });
          return _objectSpread(_objectSpread({}, node), {}, {
            data: _objectSpread(_objectSpread({}, node.data), {}, {
              properties: _objectSpread(_objectSpread({}, node.data.properties), {}, _defineProperty({}, event.payload.propertyKey, newTruthTable))
            })
          });
        }
        return node;
      })
    })
  });
}

/**
 * Changes the conditions for a row in the truth table
 */
function updateConditions(_ref28) {
  var context = _ref28.context,
    event = _ref28.event;
  return _objectSpread(_objectSpread({}, context), {}, {
    workflow: _objectSpread(_objectSpread({}, context.workflow), {}, {
      nodes: context.workflow.nodes.map(function (node) {
        if (node.id === context.selectedNodeId) {
          var _node$data$properties7;
          var result = TruthTable["default"]({
            defaultOutcome: '',
            rows: []
          }).safeParse((_node$data$properties7 = node.data.properties) === null || _node$data$properties7 === void 0 ? void 0 : _node$data$properties7[event.payload.propertyKey]);
          if (!result.success) {
            return node;
          }
          var oldTruthTable = result.data;
          var newTruthTable = _objectSpread(_objectSpread({}, oldTruthTable), {}, {
            rows: oldTruthTable.rows.map(function (row, idx) {
              if (idx === context.selectedRowIdx) {
                return _objectSpread(_objectSpread({}, row), {}, {
                  conditions: event.payload.conditions
                });
              }
              return row;
            })
          });
          return _objectSpread(_objectSpread({}, node), {}, {
            data: _objectSpread(_objectSpread({}, node.data), {}, {
              properties: _objectSpread(_objectSpread({}, node.data.properties), {}, _defineProperty({}, event.payload.propertyKey, newTruthTable))
            })
          });
        }
        return node;
      })
    })
  });
}

/**
 * Moves a case/row up in the truth table
 */
function moveCaseUp(_ref29) {
  var context = _ref29.context,
    event = _ref29.event;
  return produce(context, function (draft) {
    var _node$data$properties8;
    var node = draft.workflow.nodes.find(function (n) {
      return n.id === draft.selectedNodeId;
    });
    var truthTable = node === null || node === void 0 ? void 0 : (_node$data$properties8 = node.data.properties) === null || _node$data$properties8 === void 0 ? void 0 : _node$data$properties8[event.payload.propertyKey];
    assert(isMatching({
      rows: P.array(P._)
    }, truthTable));
    var currentRowIndex = event.payload.rowIdx;
    if (currentRowIndex <= 0) return;
    var temp = truthTable.rows[currentRowIndex - 1];
    truthTable.rows[currentRowIndex - 1] = truthTable.rows[currentRowIndex];
    truthTable.rows[currentRowIndex] = temp;
  });
}

/**
 * Moves a case/row down in the truth table
 */
function moveCaseDown(_ref30) {
  var context = _ref30.context,
    event = _ref30.event;
  return produce(context, function (draft) {
    var _node$data$properties9;
    var node = draft.workflow.nodes.find(function (n) {
      return n.id === draft.selectedNodeId;
    });
    var truthTable = node === null || node === void 0 ? void 0 : (_node$data$properties9 = node.data.properties) === null || _node$data$properties9 === void 0 ? void 0 : _node$data$properties9[event.payload.propertyKey];
    assert(isMatching({
      rows: P.array(P._)
    }, truthTable));
    var currentRowIndex = event.payload.rowIdx;
    if (currentRowIndex >= truthTable.rows.length - 1) return;
    var temp = truthTable.rows[currentRowIndex + 1];
    truthTable.rows[currentRowIndex + 1] = truthTable.rows[currentRowIndex];
    truthTable.rows[currentRowIndex] = temp;
  });
}

/**
 * Determines if a property value is "empty" and can be removed from the property object
 */
function isPropertyEmpty(value) {
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return false;
  }
  return !value;
}

/**
 * Tries to coerce a value to the data type specified by the schema
 */
function coercePropertyValue(value, schema) {
  var type = 'anyOf' in schema ? schema.anyOf[1].properties["var"].type : schema.type;
  if (type === 'number') {
    var coercedValue = Number(value);
    if (isNaN(coercedValue)) {
      throw new Error('Can not coerce value');
    }
    return coercedValue;
  }
  return value;
}
export var StateMachineContext = /*#__PURE__*/createContext(null);

/**
 * This component should wrap the page. It provides a context that enables us to
 * use other hooks and avoid prop drilling send / state
 */
export function RequirementPageStateMachineProvider(_ref31) {
  var children = _ref31.children;
  var _useRequirementTempla = useRequirementTemplate(),
    requirementTemplate = _useRequirementTempla.requirementTemplate;
  var _useReactFlow = useReactFlow(),
    setCenter = _useReactFlow.setCenter;
  return _jsx(StateMachineProvider, {
    actions: {
      setViewPortCenter: function setViewPortCenter(state) {
        var selectedNode = state.context.workflow.nodes.find(function (node) {
          return node.id === state.context.selectedNodeId;
        }) || undefined;
        if (selectedNode) return setCenter(selectedNode.position.x + 360, selectedNode.position.y + 100, {
          zoom: 1,
          duration: 800
        });
      }
    },
    form: requirementTemplate === null || requirementTemplate === void 0 ? void 0 : requirementTemplate.typeSpecificAttributes.formDefinition,
    workflow: requirementTemplate === null || requirementTemplate === void 0 ? void 0 : requirementTemplate.typeSpecificAttributes.evaluationWorkflow,
    generalInformation: getGeneralInformationFromRequirementTemplate(requirementTemplate),
    children: children
  });
}
export function StateMachineProvider(_ref32) {
  var children = _ref32.children,
    actions = _ref32.actions,
    form = _ref32.form,
    workflow = _ref32.workflow,
    generalInformation = _ref32.generalInformation;
  var actorRef = useActorRef(machine.provide({
    actions: actions
  }), {
    input: {
      form: form,
      workflow: workflow,
      generalInformation: generalInformation
    }
  });
  return _jsx(StateMachineContext.Provider, {
    value: actorRef,
    children: children
  });
}

/**
 * Returns a function that can be used to dispatch events to the state machine
 */
export function useSend() {
  var actorRef = useContext(StateMachineContext);
  if (!actorRef) {
    throw new Error('useSend must be used inside StateMachineProvider');
  }
  return actorRef.send;
}

/**
 * Returns a function that can be called to check if the current state matches
 * some expected state
 *
 * Note: xstate does not provide a performant way to get `matches` so this hook
 *       is a little complex to avoid over-rendering
 */
export function useMatches() {
  var actorRef = useContext(StateMachineContext);
  if (!actorRef) {
    throw new Error('useMatches must be used inside StateMachineProvider');
  }
  var _useSelectorXstate = useSelectorXstate(actorRef, useMemo(function () {
      return function (snapshot) {
        return {
          value: snapshot.value,
          matches: function matches(testValue) {
            return snapshot.matches(testValue);
          }
        };
      };
    }, []),
    // For performance reasons, we only want the component to re-render when
    // `state.value` changes
    //
    // You can check if this is working by opening the react dev tools and
    // checking the "Highlight updates when components rerender" checkbox.  If
    // you drag around a node you should only see the canvas re-render and not
    // the entire page.
    //
    // Note: It seems like xstate does not keep `state.value` referentially
    // equal when it does not change, so we can't use a shallow compare here.
    // Therefore, we use isEqual from lodash which does a deep comparison.
    // Since value is not a very deep object, this should be fine
    function (a, b) {
      return isEqual(a.value, b.value);
    }),
    matches = _useSelectorXstate.matches;
  return matches;
}

/**
 * Returns the current step in the requirement wizard as a number.  Checks the
 * state machine state
 */
export function useCurrentStep() {
  var matches = useMatches();
  return matches('step_1') ? 0 : matches('step_2') ? 1 : 2;
}

/**
 * Allows getting a value from the context.  A callback should be provided that
 * extracts the state value from the context.  Selectors are performant because
 * they only re-render when the selected value changes, not the entire context
 */
export function useSelector(callback, compare) {
  var actorRef = useContext(StateMachineContext);
  if (!actorRef) {
    throw new Error('useSelector must be used inside StateMachineProvider');
  }
  return useSelectorXstate(actorRef, useMemo(function () {
    return function (state) {
      return callback(state.context);
    };
  }, [callback]), compare);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function firstPropertyValue(obj) {
  return obj[Object.keys(obj)[0]];
}